import React, { useEffect, useState } from 'react'
import { BaseCard } from '@verifier-user/verifier-headless-ui'
import { InfoCDR, LoadingDialog } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const AngleSuccess = () => {
  const { onSuccess, getToken } = useApplicationContext()
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState(false)

  useEffect(() => {
    setProcessing(true)
    performRequest()
  }, [])

  const performRequest = () => {
    onSuccess({
      successFn: () => {
        sessionStorage.clear()
        localStorage.clear()
        setProcessing(false)
      },
      onError: (error) => {
        onError(error)
      }
    })
  }

  const onError = (error) => {
    sessionStorage.clear()
    localStorage.clear()
    setProcessing(false)
    setError(error)
  }

  const getErrorContent = () => {
    return (
      <div className={'mt-0 max-w-screen-md mb-10'}>
        <h1 className={'text-4xl mb-8'}>Error encountered</h1>
        <p data-testid={'modal-primary-content'}>
          We’re sorry, but we encountered an error, and we are unable to complete your income verification.
        </p>
        <p data-testid={'modal-error-content'}>
          If the issue persists, please let Verifier know by email at{' '}
          <a href='mailto:contact@verifier.me' id='errorContact-link'>
            contact@verifier.me
          </a>
          , and this will be investigated.
        </p>
      </div>
    )
  }

  return (
    <>
      <LoadingDialog id={'fnf-angle-success'} isOpen={processing} />
      {error ? (
        getErrorContent()
      ) : (
        <>
          <h1 className={'text-4xl sm:text-5xl mb-8 leading-tight'}>Congratulations</h1>

          <BaseCard className='mt-0 max-w-screen-md mb-10' data-testid='success-content'>
            <p data-testid='success-content-par-1'>Thank you, your income verification is complete.</p>
          </BaseCard>
        </>
      )}

      <InfoCDR
        accreditationLink={process.env.ACCREDITATION_LINK}
        accreditationNumber={process.env.ACCREDITATION_NUMBER}
        companyName={process.env.COMPANY}
      ></InfoCDR>
    </>
  )
}
